const server = process.env.REACT_APP_SERVER;
const serverG2 = process.env.REACT_APP_G2;


export { server, serverG2};
